import { useState, useEffect } from 'react'
import { usePWA } from '../hooks/usePWA'

export default function PWAInstallPrompt() {
  const { isInstalled, isInstallable, installApp } = usePWA()
  const [showPrompt, setShowPrompt] = useState(false)

  const pwaEnabled = import.meta.env.VITE_PWA_INSTALL_PROMPT === 'true'

  useEffect(() => {
    if (!pwaEnabled) return
    const dismissed = localStorage.getItem('pwa-install-dismissed')
    const wasRecentlyDismissed = dismissed
      ? (Date.now() - parseInt(dismissed)) < 24 * 60 * 60 * 1000
      : false

    if (!wasRecentlyDismissed) {
      const timer = setTimeout(() => setShowPrompt(true), 3000)
      return () => clearTimeout(timer)
    }
  }, [])

  if (!pwaEnabled || isInstalled || !isInstallable || !showPrompt) {
    return null
  }

  const handleInstall = async () => {
    const success = await installApp()
    if (success) setShowPrompt(false)
  }

  const handleDismiss = () => {
    setShowPrompt(false)
    localStorage.setItem('pwa-install-dismissed', Date.now().toString())
  }

  return (
    <div className="fixed bottom-4 left-4 right-4 bg-white border border-gray-200 rounded-lg shadow-lg p-4 z-50">
      <div className="flex items-start space-x-3">
        <div className="flex-shrink-0">
          <div className="w-8 h-8 bg-blue-600 rounded-lg flex items-center justify-center">
            <svg className="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 18h.01M8 21h8a2 2 0 002-2V5a2 2 0 00-2-2H8a2 2 0 00-2 2v14a2 2 0 002 2z" />
            </svg>
          </div>
        </div>
        <div className="flex-1 min-w-0">
          <h3 className="text-sm font-medium text-gray-900">Install App</h3>
          <p className="text-sm text-gray-500 mt-1">
            Install this app on your device for a better experience
          </p>
        </div>
        <button onClick={handleDismiss} className="flex-shrink-0 text-gray-400 hover:text-gray-600">
          <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
      </div>
      <div className="mt-3 flex space-x-3">
        <button onClick={handleInstall} className="btn btn-primary flex-1">Install</button>
        <button onClick={handleDismiss} className="btn btn-secondary flex-1">Not now</button>
      </div>
    </div>
  )
}
